import { Component, Input, Output, OnInit, OnDestroy } from '@angular/core';
import { FormGroup, FormControl, AbstractControl } from '@angular/forms';

import { Subscription } from 'rxjs';
import { Subject } from 'rxjs';
import { FormEditor } from './../../../models/editors/form-editor.base.model';

@Component({
  selector: 'swb-form-field',
  templateUrl: './form-field.component.html'
})

export class FormEditorComponent implements OnInit, OnDestroy {
  @Input() field: FormEditor<any>;
  @Input() form: FormGroup;
  @Output() imgOnly: boolean;
  @Input() lang: string;
  @Input() inline: boolean;

  private _subscription: Subscription;
  private _unsubscribe: Subject<boolean> = new Subject();

  public hidden = false;
  public control: any;
  public formGroup: FormGroup;

  public fieldTypeItems: any;

  public showFileBrowser: boolean;

  get isValid() { return this.control.valid; }

  ngOnInit() {

    if (this.field.formGroup) {
      this.formGroup = this.form.get(this.field.formGroup) as FormGroup;
      this.control = this.formGroup.get(this.field.key) as FormControl;
    } else if (this.field.controlType !== 'fields-row') {
      this.control = this.form.get(this.field.key) as FormControl;
    }
    if (this.field.boundTo && this.form.get(this.field.boundTo)) {
      this.hidden = this.field.hidden;
    }
    if (this.field.boundTo && this.form.get(this.field.boundTo)) {
      const boundField = this.form.get(this.field.boundTo);
      boundField.valueChanges.subscribe(data => {
        this.hidden = !data;
      });
    }
  }


  ngOnDestroy() {
    this._unsubscribe.next(true);
    this._unsubscribe.complete();

    if (this._subscription) {
      this._subscription.unsubscribe();
    }
  }

  public isString(val: any) {
    return typeof (val) === 'string';
  }

  public getControl(field: any): AbstractControl {
    return this.form.get(field.key);
  }
}
